import { Action } from '@ngrx/store';
import {
  GET_VP_ZONE_CREATED_RESPONSE, GET_VP_ZONE_CREATED_RESPONSE_FAIL,
  GET_VP_ZONE_CREATED_RESPONSE_SUCCESS, GetVPZoneCreatedResponseFail,
  GetVPZoneCreatedResponseSuccess
} from "../actions";

export interface IZoneState {
  clientInstanceData: any | null;
  loading: boolean;
  error: string | null;
}

export const initialZoneState: IZoneState = {
  clientInstanceData: null,
  loading: false,
  error: null
};

export function reducer(state = initialZoneState, action: Action): IZoneState {
  switch (action.type) {
    case GET_VP_ZONE_CREATED_RESPONSE:
      return {
        ...state,
        loading: true,
        error: null // Reset error when a new request is made
      };

    case GET_VP_ZONE_CREATED_RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        clientInstanceData: (<GetVPZoneCreatedResponseSuccess>action).payload.client_instance_data // Store response
      };

    case GET_VP_ZONE_CREATED_RESPONSE_FAIL:
      return {
        ...state,
        loading: false,
        error: (<GetVPZoneCreatedResponseFail>action).payload // Store error message
      };

    default:
      return state;
  }
}
